<!-- eslint-disable -->
<template>
  <CommonPages id="about-us" :class="['about-us-page']" :titlePrefix="'About Us'"
    :metaDescription="domainConfig?.['meta']?.des || 'Learn more about us and our mission'">
    <div class="about-us-full">
      <div class="about-us-full__container">
        <div class="about-us-full__content">
          <div class="about-us-full__title-container">
            <div class="about-us-full__title">About Us</div>
          </div>
          <div class="about-us-full__description">
            At {{ domainConfig?.IAmURL }}, we believe a great name is the first step to a powerful
            identity. Whether
            you're
            naming a character, a baby, a startup, or a story world, the right name can make all the
            difference.
            <br /><br />
            <strong>What We Do</strong><br />
            We use advanced AI to generate unique names tailored to your preferences—origin, gender,
            theme, tone, or
            meaning. Our platform delivers instant suggestions that are creative, diverse, and
            memorable.
            <br /><br />
            <strong>Why We Built This</strong><br />
            Naming is deeply personal yet often challenging. We built this site to make the process
            easier, more fun,
            and
            more inspiring—removing friction while keeping the magic.
            <br /><br />
            <strong>Our Vision</strong><br />
            To become the most intuitive, reliable, and creative AI name generator online—helping
            individuals,
            creators,
            and entrepreneurs find the perfect name for anything that matters.
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'AboutUs',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';
</style> 

<style lang="scss" scoped>
@import '@/css/variables.scss';

.about-us-page {
	background: #a31984;
}

.about-us-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;

	&__container {
		width: 100%;
		min-height: rem(800);
		position: relative;
		overflow: hidden;
	}

	&__background {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	&__bg-image {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		object-fit: cover;
	}

	&__bg-overlay {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(80) rem(180) 0;
		position: relative;
		z-index: 1;
	}

	&__title-container {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #fff;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24); /* 100% */
	}

	&__description {
		color: #fff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		position: relative;
		align-self: stretch;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.about-us-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.about-us-full {
		padding: rem(40) rem(16);

		&__container {
			min-height: rem(600);
		}

		&__content {
			width: 100%;
			padding: 0;
		}

		&__title {
			font-size: rem(28);
			line-height: rem(28);
		}

		&__description {
			font-size: rem(14);
			line-height: rem(24);
			text-align: left;
		}
	}
}
</style>